/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { SupplyChainListContainer } from './container';
import { useNavigate } from 'react-router-dom';
import appRoutes from '@/AppNavigator/services/config/routes.config.json';

export const SupplyChainListPage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();
  const routes = appRoutes?.routes;
  return (
    <SupplyChainListContainer
      onCardClick={(data: any) => {
        console.log('SupplyChainListContainer data', data);
        navigate(routes?.SupplyChainStep?.path, {
          state: { detail: data },
        });
      }}
    />
  );
};
